
import Picker from 'vux/src/components/picker/index.vue'

import shadowWrap from '@/components/shadow';
import { mapGetters, mapActions } from 'vuex';
export default {
components: { shadowWrap, Picker },
name: 'information-editing',
data() {
return {
picUrl: './images/teacher6.png',
year7: [
{
name: '中国',
value: 'china',
parent: 0
},
{
name: '美国',
value: 'USA',
parent: 0
},
{
name: '广东',
value: 'china001',
parent: 'china'
},
{
name: '广西',
value: 'china002',
parent: 'china'
},
{
name: '美国001',
value: 'usa001',
parent: 'USA'
},
{
name: '美国002',
value: 'usa002',
parent: 'USA'
},
{
name: '广州',
value: 'gz',
parent: 'china001'
},
{
name: '深圳',
value: 'sz',
parent: 'china001'
},
{
name: '广西001',
value: 'gz',
parent: 'china002'
},
{
name: '广西002',
value: 'sz',
parent: 'china002'
},
{
name: '美国001_001',
value: '0003',
parent: 'usa001'
},
{
name: '美国001_002',
value: '0004',
parent: 'usa001'
},
{
name: '美国002_001',
value: '0005',
parent: 'usa002'
},
{
name: '美国002_002',
value: '0006',
parent: 'usa002'
}
],
year7Value: [],
year8Value: [],
region: '',
regionIm: '',
citySwite: false,
numberSwite: false,
getCodeText: '获取验证码',
phoneNum: '',
codeSwite: true
};
},
methods: {
...mapActions([]),
picChange(e) {
let that = this;
let file = event.target.files[0];
let reader = new FileReader();
reader.readAsDataURL(file);
reader.onload = function(e) {
let url = e.target.result;
that.picUrl = url;
};
},
getAerNum() {
this.numberSwite = !this.numberSwite;
},
getCode() {
let num = 10;
const that = this;
let funSet = function() {
num--;
if (num <= 0) {
num = 10;
that.getCodeText = '获取验证码';
that.codeSwite = true;
return;
}
that.getCodeText = num + 's后重新获取';
setTimeout(() => {
funSet();
}, 1000);
};
if (this.codeSwite) {
this.codeSwite = false;
funSet();
}
},
getAer() {
this.citySwite = !this.citySwite;
},
getregionIm() {
this.regionIm = this.region;
this.getAer();
},
change(value) {
let key = value[1];
let cont = '';
for (let i = 0; i < this.year7.length; i++) {
if (key === this.year7[i].parent) {
cont = this.year7[i].name;
break;
}
}
this.region = cont;
}
},
watch: {},
computed: {
...mapGetters([])
},
created() {},
mounted() {}
};
